/**
 * 路由配置 论坛
 * key需要与后台返回的 module_url 对应
 */

export default () =>{
    return {
        Index:{
            path:'/forum-index/:lang/:meeting_id/:forum_id',
            component: () => import( /* webpackChunkName: "Index" */ '../views-forum/index.vue'),
        },

        /**************  会议配置  ****************/ 
        // 会议基本信息配置
        MeetingConfigInfo:{
            path:'/forum-config/info/:lang/:meeting_id/:forum_id',
            component: () => import( /* webpackChunkName: "MeetingConfigInfo" */ '../views-forum/forum-config/info.vue'),
        },
        // 默认首页设置
        MeetingConfigDefaultPage:{
            path:'/forum-config/default-page/:lang/:meeting_id/:forum_id',
            component: () => import( /* webpackChunkName: "MeetingConfigDefaultPage" */ '../views/meeting-config/default-page.vue'),
        },
        // 默认图片设置
        MeetingConfigImagePage:{
            path:'/forum-config/default-image/:lang/:meeting_id/:forum_id',
            component: () => import( /* webpackChunkName: "MeetingConfigImagePage" */ '../views/meeting-config/default-image.vue'),
        },

        /**************  PC网站配置 - 中文  ****************/ 
        // 注册表单设置
        ForumConfigFormCn:{
            path:'/forum-config/cn-form/:lang/:meeting_id/:forum_id',
            component: () => import( /* webpackChunkName: "ForumConfigFormCn" */ '../views/form-config/form.vue'),
        },
        // 网站基本配置
        WebConfigInfoCn:{
            path: '/forum-web-config/cn-info/:lang/:meeting_id/:forum_id',
            component: () => import('../views/web-config/info.vue')
        },
        // 模版风格配置
        WebConfigStyleCn:{
            path: '/forum-web-config/cn-style/:lang/:meeting_id/:forum_id',
            component: () => import('../views/web-config/style.vue')
        },
        // 首页栏目配置
        WebConfigPageContentCn:{
            path: '/forum-web-config/cn-page-content/:lang/:meeting_id/:forum_id',
            component: () => import('../views/web-config/page-content.vue')
        },
        // 导航栏目配置
        WebConfigNavListCn:{
            path: '/forum-web-config/cn-nav-list/:lang/:meeting_id/:forum_id',
            component: () => import('../views/web-config/nav-list.vue')
        },

        /**************  PC网站配置 - 英文  ****************/ 
        // 注册表单设置
        ForumConfigFormEn:{
            path:'/forum-config/en-form/:lang/:meeting_id/:forum_id',
            component: () => import( /* webpackChunkName: "ForumConfigFormEn" */ '../views/form-config/form.vue'),
        },
        // 网站基本配置
        WebConfigInfoEn:{
            path: '/forum-web-config/en-info/:lang/:meeting_id/:forum_id',
            component: () => import('../views/web-config/info.vue')
        },
        // 模版风格配置
        WebConfigStyleEn:{
            path: '/forum-web-config/en-style/:lang/:meeting_id/:forum_id',
            component: () => import('../views/web-config/style.vue')
        },
        // 首页栏目配置
        WebConfigPageContentEn:{
            path: '/forum-web-config/en-page-content/:lang/:meeting_id/:forum_id',
            component: () => import('../views/web-config/page-content.vue')
        },
        // 导航栏目配置
        WebConfigNavListEn:{
            path: '/web-config/en-nav-list/:lang/:meeting_id/:forum_id',
            component: () => import('../views/web-config/nav-list.vue')
        },

        /**************  Mobile网站配置 - 中文  ****************/ 
        // 基本配置
        MobileConfigInfoCn:{
            path: '/forum-mobile-config/cn-info/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/info.vue')
        },
        // 风格配置
        MobileConfigStyleCn:{
            path: '/mobile-config/cn-style/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/style.vue')
        },
        // 顶部轮播配置
        MobileConfigBannerCn:{
            path: '/forum-mobile-config/cn-banner/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/banner.vue')
        },
        // 导航栏目配置
        MobileConfigNavListCn:{
            path: '/forum-mobile-config/cn-nav-list/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/nav-list.vue')
        },
        // 广告配置
        MobileConfigAdCn:{
            path: '/forum-mobile-config/cn-ad/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/advertising.vue')
        },

        /**************  Mobile网站配置 - 英文  ****************/ 
        // 基本配置
        MobileConfigInfoEn:{
            path: '/forum-mobile-config/en-info/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/info.vue')
        },
        // 风格配置
        MobileConfigStyleEn:{
            path: '/forum-mobile-config/en-style/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/style.vue')
        },
        // 顶部轮播配置
        MobileConfigBannerEn:{
            path: '/forum-mobile-config/en-banner/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/banner.vue')
        },
        // 导航栏目配置
        MobileConfigNavListEn:{
            path: '/forum-mobile-config/en-nav-list/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/nav-list.vue')
        },
        // 广告配置
        MobileConfigAdEn:{
            path: '/forum-mobile-config/en-ad/:lang/:meeting_id/:forum_id',
            component: () => import('../views/mobile-config/advertising.vue')
        },

        /**************  商品管理  ****************/
        // 商品管理
        GoodsModuleGoods:{
            path: '/forum-goods/goods/:lang/:meeting_id/:forum_id',
            component: () => import('../views-forum/goods-module/goods.vue')
        },
        // 分类管理
        GoodsModuleClassify:{
            path: '/forum-goods/classify/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/classify.vue')
        },
        // 订单管理
        OrderModuleIndex:{
            path: '/forum-goods/order/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/order-list.vue')
        },

        /**************  促销管理  ****************/
        // 阶梯促销
        GoodsModuleLadderPromotion:{
            path: '/forum-goods/ladder-promotion/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/promotion/ladder-promotion.vue')
        },
        // 满减促销
        GoodsModuleMaxOutPromotion:{
            path: '/forum-goods/max-out-promotion/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/promotion/max-out-promotion.vue')
        },
        // 搭配促销
        GoodsModuleMatchPromotion:{
            path: '/forum-goods/match-promotion/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/promotion/match-promotion.vue')
        },
        // 优惠券
        GoodsModuleDiscountPromotion:{
            path: '/forum-goods/discount-promotion/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/promotion/discount-promotion.vue')
        },
        // 营销规则
        GoodsModuleMarketingRule:{
            path: '/forum-goods/marketing-rule/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/marketing-rules.vue')
        },
        // 渠道推广
        GoodsModuleChannel : {
            path: '/forum-goods/channel/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/channel.vue')
        },

        /**************  用户管理  ****************/
        // 用户管理
        UserModuleIndex:{
            path: '/forum-user/index/:lang/:meeting_id/:forum_id',
            component: () => import('../views/user-module/index.vue')
        },
        //身份验证配置
        UserModuleIdentity:{
            path: '/forum-user/identity/:lang/:meeting_id/:forum_id',
            component: () => import('../views/user-module/identity.vue')
        },

        // 注册参数-中宾注册参数
        ForumUserParamsConfigCn: {
            path: '/forum-user/params-config-cn/:lang/:meeting_id/:forum_id',
            component: () => import('../views/user-module/user-params-config.vue')
        },
        // 注册参数-外宾注册参数
        ForumUserParamsConfigEn: {
            path: '/forum-user/params-config-en/:lang/:meeting_id/:forum_id',
            component: () => import('../views/user-module/user-params-config.vue')
        },
        
        // 购票参数配置-中宾配置
        ForumRegisterSetingCn: {
            path: '/forum-goods/register-setting-cn/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/register-setting.vue')
        },
        // 购票参数配置-外宾配置
        ForumRegisterSetingEn: {
            path: '/forum-goods/register-setting-en/:lang/:meeting_id/:forum_id',
            component: () => import('../views/goods-module/register-setting.vue')
        },
    }
}

      